__turbopack_context__.v({
  "className": "roboto_52dd019f-module__ja5_KG__className",
  "variable": "roboto_52dd019f-module__ja5_KG__variable",
});
